import { type PropsWithChildren } from 'react';

import { HeartIcon } from '@sorare/core/src/atoms/icons/HeartIcon';
import { range } from '@sorare/core/src/lib/arrays';
import type { unitMapping } from '@sorare/core/src/lib/style';

type Props = {
  task: {
    maxLineupsCount: number;
    remainingLineupsCount: number;
    pendingLineupsCount: number;
  };
  size?: keyof typeof unitMapping;
};

export const Lifes = ({ task, size = 2 }: PropsWithChildren<Props>) => {
  const getStatus = (index: number) => {
    if (index < task.remainingLineupsCount) {
      return 'active';
    }
    if (index < task.pendingLineupsCount) {
      return 'pending';
    }
    return 'inactive';
  };
  return (
    <>
      {range(task.maxLineupsCount).map(i => (
        <HeartIcon key={i} status={getStatus(i)} size={size} />
      ))}
    </>
  );
};
